import React from 'react';
import { Snackbar, Portal, Alert, AlertColor } from '@mui/material';

interface AlertSnackbarProps {
    open: boolean;
    onClose: () => void;
    message: string;
    severity?: AlertColor; // Pode ser "error", "warning", "info", "success"
}

const AlertSnackbar: React.FC<AlertSnackbarProps> = ({ open, onClose, message, severity = 'error' }) => {
    return (
        <Portal>
        <Snackbar
            open={open}
            autoHideDuration={10000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            sx={{ position: 'fixed', zIndex: 1400 }}
        >
            <Alert onClose={onClose} severity={severity} sx={
                {
                    width: '100%',
                    whiteSpace: 'pre-line'
                }}>
                {message}
            </Alert>
        </Snackbar>
        </Portal>
    );
};

export default AlertSnackbar;